// extracted by mini-css-extract-plugin
export var gif = "_f6-0";